import { defineStore } from "pinia";

export interface KeepAliveState {
    keepAliveName: string[];
    /** 缓存表单 fullPath */
    cacheFormArr: string[];
    /** 缓存表单 name（页面key）,fullPath（可能带id的路径） map */
    cacheFormMap: Map<string, string>;
}

/** 页面缓存状态 */
export const useKeepAliveStore = defineStore({
    id: "zhongsheng-keepAlive",
    state: (): KeepAliveState => ({
        keepAliveName: [],
        cacheFormMap: new Map(),
        cacheFormArr: []
    }),
    actions: {
        // Add KeepAliveName
        addKeepAliveName(name: string) {
            !this.keepAliveName.includes(name) && this.keepAliveName.push(name);
        },
        // Remove KeepAliveName
        removeKeepAliveName(name: string) {
            this.keepAliveName = this.keepAliveName.filter(item => item !== name);
        },
        // Set KeepAliveName
        setKeepAliveName(keepAliveName: string[] = []) {
            this.keepAliveName = keepAliveName;
        },
        /** 添加缓存的表单页 */
        addCacheForm(name: string, fullPath: string) {
            if (this.cacheFormMap.has(name)) {
                // 当前页面已缓存，进行替换
                this.cacheFormMap.set(name, fullPath);
                const index = this.cacheFormArr.indexOf(fullPath);
                this.cacheFormArr.splice(index, 1);
                this.cacheFormArr.push(fullPath);
            } else {
                this.cacheFormMap.set(name, fullPath);
                this.cacheFormArr.push(fullPath);
                // 最多缓存10个
                if (this.cacheFormArr.length > 10) {
                    this.cacheFormMap.delete(this.cacheFormArr[0]);
                    this.cacheFormArr.shift();
                }
            }
        },
        /** 删除缓存的表单页 */
        deleteCacheForm(name: string) {
            const value = this.cacheFormMap.get(name);
            if (!value) return;
            const index = this.cacheFormArr.indexOf(value);
            this.cacheFormArr.splice(index, 1);
            this.cacheFormMap.delete(name);
        }
    }
});
